"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UserPresenceService {
    constructor($window, $log, $rootScope, XucLink, $translate) {
        this.$window = $window;
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.XucLink = XucLink;
        this.$translate = $translate;
        this._userPresences = new Map();
        this.unInit = () => {
            this.$log.info('Unloading UserPresence service');
            this._userPresences.clear();
        };
    }
    forceScopeDigest() {
        if (!this.$rootScope.$$phase)
            this.$rootScope.$apply();
    }
    init() {
        var _a;
        this.$log.info('Starting UserPresence service');
        this.XucLink.whenLoggedOut().then(this.unInit);
        (_a = this.$window.Cti) === null || _a === void 0 ? void 0 : _a.setHandler(this.$window.Cti.MessageType.PRESENCESTATUSEVENT, this.onGetPresenceStatus.bind(this));
    }
    onGetPresenceStatus({ identifier, status }) {
        var _a;
        const title = this.getUserPresenceTitle(identifier, status);
        const icon = this.getUserPresenceIcon(identifier, status);
        const presence = (_a = this._userPresences.get(identifier)) !== null && _a !== void 0 ? _a : { identifier, status, title, icon };
        Object.assign(presence, { status, title, icon });
        this._userPresences.set(identifier, presence);
        this.forceScopeDigest();
    }
    getEnrichedUserPresence(identifier) {
        return this._userPresences.get(identifier);
    }
    getUserPresence(identifier) {
        var _a;
        return (_a = this._userPresences.get(identifier)) === null || _a === void 0 ? void 0 : _a.status;
    }
    getUserPresenceTitle(identifier, status) {
        var _a;
        const presence = (_a = status !== null && status !== void 0 ? status : this.getUserPresence(identifier)) !== null && _a !== void 0 ? _a : 'Unknown';
        const key = `USER_PRESENCE_${presence.toUpperCase()}`;
        return this.$translate.instant(key);
    }
    getUserPresenceIcon(identifier, status) {
        switch (status !== null && status !== void 0 ? status : this.getUserPresence(identifier)) {
            case 'Available': return 'xivo-user-presence-available';
            case 'Away':
            case 'BeRightBack': return 'xivo-user-presence-away';
            case 'Busy': return 'xivo-user-presence-busy';
            case 'DoNotDisturb': return 'xivo-user-presence-dnd';
            case 'Offline': return 'xivo-user-presence-offline';
            case 'OutOfOffice': return 'xivo-user-presence-available';
            default: return '';
        }
    }
}
exports.default = UserPresenceService;
UserPresenceService.$inject = ['$window', '$log', "$rootScope", 'XucLink', "$translate"];
